import {MainScreenDefaultBox} from './main-screen.default.box';
import styled from 'styled-components';
import {
    BLACKJACK_PAGE,
    CASINO_GAMES_PAGE,
    ROULETTE_PAGE, SCRATCH_CARDS_PAGE,
    SLOTS_PAGE,
    VIDEO_POKER_PAGE
} from '../../../themes/css-global-classes';
import {Color} from '../../../themes/definitions/casino888/casino888-colors';


export const MainScreenCasino888Box = styled(MainScreenDefaultBox)`
    background-attachment: fixed;
   
    .${SLOTS_PAGE} & {
        background: radial-gradient(ellipse at center, ${Color.lightBlack} 0%, ${Color.black} 100%);
    }
    
    .${CASINO_GAMES_PAGE} & {
        background: radial-gradient(ellipse at center, ${Color.darkGreen} 0%, ${Color.blackGreen} 100%);
    }
    
    .${VIDEO_POKER_PAGE} & {
        background: radial-gradient(ellipse at center, ${Color.vidPoker} 0%, ${Color.black} 100%);
    }
    
    .${ROULETTE_PAGE} &, .${BLACKJACK_PAGE} & {
        background: radial-gradient(ellipse at center, ${Color.roulBJ} 0%, ${Color.black} 100%);
    }
    
    .${SCRATCH_CARDS_PAGE} & {
        background: radial-gradient(ellipse at center, ${Color.scCards} 0%, ${Color.black} 100%);
    }
`;